/* Loofys: popup die een abonnement aanbiedt als iemand 3+ stuks van hetzelfde product los in het mandje heeft.
   - Alleen producten met de Progus-groep "Abonneer en bespaar" (de plannen komen uit /products/<handle>.js).
   - Alleen regels zonder abonnement. Eén keer per product per sessie. */
(function () {
  if (window.__loofysAboPopup) return;
  window.__loofysAboPopup = true;

  var GROUP_NAME = 'Abonneer en bespaar';
  var MIN_QTY = 3;
  var SEEN_KEY = 'loofys_abo_popup_seen';
  var planCache = {};
  var checking = false;
  var timer = null;
  var popup = null;
  var lastFocus = null;
  var pausedTrap = null;

  function root() {
    return (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  }

  /* De winkelwagenlade vangt zolang hij open is alle aanrakingen buiten zichzelf af (focusval) en sluit bij een klik
     erbuiten. De popup staat buiten de lade, dus daar kon je op een telefoon niets meer aanraken. Daarom zetten we de
     focusval van de lade op pauze zolang de popup open is, en halen we hem daarna weer terug. */
  function pauseDrawerTrap() {
    try {
      var drawer = document.querySelector('cart-drawer');
      if (drawer && drawer.hasAttribute('open') && drawer.focusTrap) {
        drawer.focusTrap.pause();
        pausedTrap = drawer.focusTrap;
      }
    } catch (e) { pausedTrap = null; }
  }

  function resumeDrawerTrap() {
    try { if (pausedTrap) pausedTrap.unpause(); } catch (e) {}
    pausedTrap = null;
  }

  /* Vangnet: ook zonder focusval-pauze mag een klik in de popup de lade niet sluiten. */
  function protectDrawerFromPopupClicks() {
    var drawer = document.querySelector('cart-drawer');
    if (!drawer || drawer.__loofysPopupGuard) return;
    drawer.__loofysPopupGuard = true;
    var originalHide = drawer.hideForOutsideClickTarget;
    var originalAllow = drawer.allowOutsideClickForTarget;
    drawer.hideForOutsideClickTarget = function (target) {
      if (target && target.closest && target.closest('.loofys-abo-popup')) return false;
      return originalHide ? originalHide.call(this, target) : !this.contains(target);
    };
    drawer.allowOutsideClickForTarget = function (target) {
      if (target && target.closest && target.closest('.loofys-abo-popup')) return true;
      return originalAllow ? originalAllow.call(this, target) : false;
    };
  }

  function getSeen() {
    try { return JSON.parse(sessionStorage.getItem(SEEN_KEY) || '[]'); } catch (e) { return []; }
  }

  function markSeen(handle) {
    try {
      var seen = getSeen();
      if (seen.indexOf(handle) === -1) seen.push(handle);
      sessionStorage.setItem(SEEN_KEY, JSON.stringify(seen));
    } catch (e) {}
  }

  function discountOf(name) {
    var m = /(\d+)% korting/.exec(name || '');
    return m ? m[1] : '';
  }

  function frequencyOf(name) {
    return String(name || '').split(',')[0].replace(' bezorgen', '').trim();
  }

  function getPlans(handle) {
    if (!planCache[handle]) {
      planCache[handle] = fetch(root() + 'products/' + handle + '.js', { headers: { Accept: 'application/json' } })
        .then(function (r) { return r.ok ? r.json() : null; })
        .then(function (product) {
          if (!product || !product.selling_plan_groups) return null;
          var group = product.selling_plan_groups.find(function (g) { return g.name === GROUP_NAME; });
          if (!group || !group.selling_plans || !group.selling_plans.length) return null;
          return group.selling_plans.map(function (sp) { return { id: sp.id, name: sp.name }; });
        })
        .catch(function () { return null; });
    }
    return planCache[handle];
  }

  function closePopup() {
    resumeDrawerTrap();
    if (!popup) return;
    document.removeEventListener('keydown', onKeydown, true);
    popup.remove();
    popup = null;
    if (lastFocus && lastFocus.focus) { try { lastFocus.focus(); } catch (e) {} }
  }

  function onKeydown(e) {
    if (e.key === 'Escape' && popup) {
      popup.dispatchEvent(new CustomEvent('loofys-abo-dismiss'));
    }
  }

  function showPopup(item, plans) {
    if (popup) return;
    protectDrawerFromPopupClicks();
    pauseDrawerTrap();
    lastFocus = document.activeElement;

    var defaultIndex = 0;
    plans.forEach(function (p, i) { if (/3 maanden/.test(p.name)) defaultIndex = i; });

    popup = document.createElement('div');
    popup.className = 'loofys-abo-popup';
    popup.setAttribute('role', 'dialog');
    popup.setAttribute('aria-modal', 'true');
    popup.setAttribute('aria-labelledby', 'loofys-abo-title');

    var box = document.createElement('div');
    box.className = 'loofys-abo-popup__box';

    var closeBtn = document.createElement('button');
    closeBtn.type = 'button';
    closeBtn.className = 'loofys-abo-popup__close';
    closeBtn.setAttribute('aria-label', 'Sluiten');
    closeBtn.textContent = '×';

    var title = document.createElement('h2');
    title.className = 'loofys-abo-popup__title';
    title.id = 'loofys-abo-title';
    title.textContent = 'Je hebt ' + item.quantity + 'x ' + item.product_title + ' in je mandje';

    var text = document.createElement('p');
    text.className = 'loofys-abo-popup__text';
    text.textContent = 'Wist je dat je dit ook als abonnement kunt krijgen? Het komt dan automatisch bij je thuis, met korting en gratis verzending. Je kunt altijd opzeggen.';

    var label = document.createElement('label');
    label.className = 'loofys-abo-popup__label';
    label.setAttribute('for', 'loofys-abo-select');
    label.textContent = 'Hoe vaak wil je het ontvangen?';

    var select = document.createElement('select');
    select.className = 'loofys-abo-popup__select';
    select.id = 'loofys-abo-select';
    plans.forEach(function (p, i) {
      var opt = document.createElement('option');
      opt.value = p.id;
      opt.textContent = frequencyOf(p.name) + ', ' + discountOf(p.name) + '% korting';
      if (i === defaultIndex) opt.selected = true;
      select.appendChild(opt);
    });

    var primary = document.createElement('button');
    primary.type = 'button';
    primary.className = 'loofys-abo-popup__primary';
    primary.textContent = 'Zet om naar abonnement';

    var secondary = document.createElement('button');
    secondary.type = 'button';
    secondary.className = 'loofys-abo-popup__secondary';
    secondary.textContent = 'Nee, eenmalig kopen';

    var error = document.createElement('p');
    error.className = 'loofys-abo-popup__error';
    error.hidden = true;

    box.appendChild(closeBtn);
    box.appendChild(title);
    box.appendChild(text);
    box.appendChild(label);
    box.appendChild(select);
    box.appendChild(primary);
    box.appendChild(secondary);
    box.appendChild(error);
    popup.appendChild(box);
    document.body.appendChild(popup);
    document.addEventListener('keydown', onKeydown, true);
    primary.focus();

    function dismiss() {
      markSeen(item.handle);
      closePopup();
    }

    popup.addEventListener('loofys-abo-dismiss', dismiss);
    closeBtn.addEventListener('click', dismiss);
    secondary.addEventListener('click', dismiss);
    popup.addEventListener('click', function (e) { if (e.target === popup) dismiss(); });

    primary.addEventListener('click', function () {
      primary.disabled = true;
      error.hidden = true;
      fetch(root() + 'cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
        body: JSON.stringify({ id: item.key, quantity: item.quantity, selling_plan: Number(select.value) })
      })
        .then(function (r) {
          if (!r.ok) throw new Error('change failed');
          return r.json();
        })
        .then(function () {
          markSeen(item.handle);
          closePopup();
          document.dispatchEvent(new CustomEvent('cart:refresh'));
          if (/^\/cart\/?$/.test(location.pathname)) location.reload();
        })
        .catch(function () {
          primary.disabled = false;
          error.textContent = 'Het omzetten is niet gelukt. Je kunt het ook kiezen op de productpagina.';
          error.hidden = false;
        });
    });
  }

  function check() {
    if (checking || popup) return;
    checking = true;
    fetch(root() + 'cart.js', { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        var seen = getSeen();
        var candidates = (cart.items || []).filter(function (i) {
          return i.quantity >= MIN_QTY && !i.selling_plan_allocation && seen.indexOf(i.handle) === -1 && i.final_line_price > 0;
        });
        return candidates.reduce(function (chain, item) {
          return chain.then(function (found) {
            if (found) return found;
            return getPlans(item.handle).then(function (plans) {
              return plans ? { item: item, plans: plans } : null;
            });
          });
        }, Promise.resolve(null));
      })
      .then(function (found) { if (found) showPopup(found.item, found.plans); })
      .catch(function () {})
      .then(function () { checking = false; });
  }

  function schedule() {
    clearTimeout(timer);
    timer = setTimeout(check, 700);
  }

  var originalFetch = window.fetch;
  window.fetch = function (input) {
    var url = typeof input === 'string' ? input : (input && input.url) || '';
    var promise = originalFetch.apply(this, arguments);
    if (/\/cart\/(add|change|update)(\.js)?(\?|$)/.test(url)) {
      promise.then(schedule, function () {});
    }
    return promise;
  };

  document.addEventListener('cart:refresh', schedule);
  protectDrawerFromPopupClicks();
  if (/^\/cart\/?$/.test(location.pathname)) schedule();
})();
